// extracted by mini-css-extract-plugin
export default {"button":"ViewButton_button__X94SV","view":"ViewButton_view__wOCOs","process":"ViewButton_process__6-rtz","icon":"ViewButton_icon__xAD2y"};